const Menu = function(){

    
    const scrollHeader = function (el) {

        let headerH = $(el).height();
        if( $(window).scrollTop() > ($(el).hasClass('header-fixed') ? headerH / 2 :  headerH * 2)){
            if(!$(el).hasClass('opened'))
            {
                $("#webdoor-start").addClass('upWebdoor');
                $(el).addClass('scrolling');
            }
        } else{
            $("#webdoor-start").removeClass('upWebdoor');
            $(el).removeClass('scrolling');
        }
    }

    const toggleMenu = function (el) {

        var layerMenu = $("#layer-menu");

        if($(el).attr('id') != 'wrap-sandwitch') {
            el = "#wrap-sandwitch";
        }
        $(el).toggleClass("motion-in");
        $(el).closest('header').toggleClass("header-opened").find('nav').toggleClass("motion-in");


        //hide search
        $("#call-search").toggle();

        layerMenu.toggleClass("motion-in");

        if(layerMenu.hasClass("motion-in")){
            $('html,body').addClass('no-scroll');
        }else{
            $('html,body').removeClass('no-scroll');
        }

    }

    const toggleAccordionMob = function (el)
    {
        $('.wrap-ul-exp').find('>ul').slideUp(25);
        if($(el).closest('.wrap-ul-exp').find('>ul').is(":visible")){
            $(el).closest('.wrap-ul-exp').find('>ul').slideUp(25);
        }else{
            $(el).closest('.wrap-ul-exp').find('>ul').slideDown(25);
        }
    }


    return {
        init : function () {

            scrollHeader("#header");

            $(window).on('scroll', function(){
                scrollHeader("#header");
            });

            $("#wrap-sandwitch, #nav-header a:not(.act-link)").on("click", function(){
                toggleMenu(this);
            });
            
            if( $(window).width() <= 768 ){
                $(".toggle-mob").on("click", function(){
                    toggleAccordionMob(this);
                });
            }
        }
    }

}();

module.exports = Menu;